import { Navigate, useParams, useLocation } from 'react-router-dom';

export function EnRedirect() {
  const { '*': rest } = useParams();
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: rest ? `/${rest}` : '/', search, hash }} replace />;
}

// 旧 /request-quote（見積依頼ページ）の転送先。ページは Issue #15 で削除した。
// サイト内に導線が無く、見積の入口はすべて /contact?type=quote に向いていたため。
// 直リンクと外部からの被リンクが 404 にならないよう転送のみ残す。
// hash は引き継がない（削除したページ固有のアンカーを指しており転送先に存在しないため）。
export function RequestQuoteRedirect() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  params.set('type', 'quote');
  return <Navigate to={{ pathname: '/contact', search: `?${params.toString()}` }} replace />;
}

export const Loader = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-daishin-navy"></div>
  </div>
);
